import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,


  ValidationErrors, ValidatorFn, Validators
} from '@angular/forms';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MensajesRespuestas } from '~shared/constants/mensajeRespuesta';
import { Ciudad } from '~shared/models/ciudad';
import { RegistroMen, RegistroUsuariosMen } from '~shared/models/registro';
import { CiudadesService } from '~shared/servicios/ciudades.service';
import { ServicesService } from '~shared/servicios/services.service';
import { UsuariosService } from '~shared/servicios/usuarios.service';
import { FileService } from '../../../../shared/servicios/file.service';
import { environment } from '~environment';

@Component({
  selector: 'app-mensajeros-registro',
  templateUrl: './mensajeros-registro.component.html',
  styleUrls: ['./mensajeros-registro.component.scss'],
})
export class MensajerosRegistroComponent implements OnInit {
  @ViewChild('stepper') stepper;
  isLinear = true;
  registroFormGroup1: FormGroup;
  registroFormGroup2: FormGroup;
  registroFormGroup3: FormGroup;

  ciudadSelected: Ciudad;
  optionsCiudades: Ciudad[];
  Cities: any[];
  filteredOptions: Observable<Ciudad[]>;
  nosoSelected: string;

  paises;
  selectPais;

  succes = false;
  isVisible: boolean;

  file;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  nombreUsu: any = '';

  vistaRegistro: boolean = false;

  idTienda;


  /*medioTransporte: any[] = ["automovil", "moto", "scooter", "bicicleta"];
  medioTransSelected: string;*/

  constructor(
    private formBuilder: FormBuilder,
    private SpinnerService: NgxSpinnerService,
    private ciudadesService: CiudadesService,
    private usuarioService: UsuariosService,
    private fileUploadService: FileService,
    public service: ServicesService
  ) {
    this.isVisible = true;
  }

  ngOnInit(): void {
    this.createForm();
    this.loadPaises();
  }

  clickM() {
    this.service.emitChange(true);
  }

  listenChangesOfHeader(event) {
    this.vistaRegistro = true;
  }

  closeModal(event): void {
    this.vistaRegistro = false;
  }

  createForm(): void {
    this.registroFormGroup1 = this.formBuilder.group({
      nombreCompleto: ['', [Validators.required, Validators.maxLength(45), Validators.pattern('^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9]+(?: [a-zA-ZáéíóúÁÉÍÓÚñÑ0-9]+)*$')]],
      email: [
        '',
        [Validators.required, Validators.maxLength(60), Validators.email],
      ],
      direccion: ['', [Validators.required, Validators.maxLength(45), Validators.pattern('[a-zA-Z0-9 #-]*')]],
      pais: [''],
      ciudad: ['', Validators.required],
      telefono: ['', [Validators.required, Validators.maxLength(12)]],
      usuario: [
        '',
        [
          Validators.required,
          Validators.maxLength(15),
          Validators.pattern('[a-zA-Z0-9]*'),
          this.validatorUsuario(),
        ],
      ],
      imagen: ['', Validators.required],
    });
    this.registroFormGroup2 = this.formBuilder.group({
      placa: ['', [Validators.required, Validators.maxLength(7), Validators.pattern('[a-zA-Z0-9]*')]],
      /*medioTransporte: ['', [Validators.required, Validators.maxLength(50)]],*/
    });
  }

  //VALIDA EL USUARIO
  private validatorUsuario(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!!this.registroFormGroup1) {
        const usuario = this.registroFormGroup1.get('usuario').value;
        if (usuario.indexOf(' ') >= 0) {
          this.registroFormGroup1.get('usuario').setErrors({ required: true });
        } else {
          if (usuario) {
            return this.usuarioService.getUsuario(usuario).subscribe((resp) => {
              if (resp) {
                const respuesta = resp[0];
                const comparacion = (MensajesRespuestas.REGISTRO_YA_EXISTE === respuesta.id_response);
                if (comparacion === true) {
                  this.registroFormGroup1.get('usuario').setErrors({ required: true });
                  return { requiredValue: true };
                } else {
                  this.desmarcarErrorCampoForm1('usuario', 1);
                  return null;
                }
              }
            });
          }
        }
      }
    };
    return null;
  }

  getControl(control: string, group: number): AbstractControl {
    /* tslint:disable */
    if (group === 1) return this.registroFormGroup1.get(control);
    if (group === 2) return this.registroFormGroup2.get(control);
    if (group === 3) return this.registroFormGroup3.get(control);
    /* tslint:enable */
  }

  //DESMARCA LOS ERRORES EN LOS CAMPOS
  private desmarcarErrorCampoForm1(control: string, group: number): void {
    /* tslint:disable */
    if (group === 1)
      return this.registroFormGroup1.get(control).setErrors(null);
    if (group === 2)
      return this.registroFormGroup2.get(control).setErrors(null);
    if (group === 3)
      return this.registroFormGroup3.get(control).setErrors(null);
    /* tslint:enable */
  }

  loadPaises(): void {
    this.ciudadesService.getPaises().subscribe((dataPais) => {
      let pos;
      this.paises = dataPais;
      // console.log(this.paises);
      this.paises.find((elem, index) => {
        if (elem.pais === 'Colombia') {
          pos = index;
        }
      })
      this.selectPais = this.paises[pos];
      this.loadCiudades(this.selectPais.pais);
    });
  }

  selectPaisChange(e): void {
    // console.log('cambio', this.selectPais);
    this.loadCiudades(this.selectPais.pais);
  }

  loadCiudades(country): void {
    this.ciudadesService.getCiudadesmen(country).subscribe((ciudades) => {
      // console.log(ciudades)
      this.optionsCiudades = ciudades;
      this.Cities = ciudades;
      this.addListeners();
    });
  }

  addListeners(): void {
    this.filteredOptions = this.registroFormGroup1
      .get('ciudad')
      .valueChanges.pipe(
        startWith(''),
        map((value) => {
          return this.ciudadFilter(value);
        })
      );
  }

  private ciudadFilter(ciudad: string): Ciudad[] {
    ciudad = ciudad === null ? '' : ciudad;
    const filterValue = ciudad.toLowerCase();
    const filtered = this.optionsCiudades.filter((option) =>
      option.ciudad.toLowerCase().includes(filterValue)
    );
    if (filtered.length > 0) {
      return filtered;
    } else {
      this.registroFormGroup1.get('ciudad').setErrors({ required: true });
      return [];
    }
  }

  //OPCION SELECCIONADA EN CIUDAD
  onSelectedOption(ciudad: Ciudad, e): void {
    if (e.isUserInput) {
      this.ciudadSelected = ciudad;
      // console.log(this.ciudadSelected)
    }
  }

  //OPCION SELECCIONADA EN CIUDAD
  onSelectedOption2(nosotros: string): void {
    this.nosoSelected = nosotros;
  }

  saveInfo(): void {
    if (this.registroFormGroup1.valid && this.registroFormGroup2.valid) {
      const valueFOrmRegistro: any = {
        ...this.registroFormGroup1.value,
        ...this.registroFormGroup2.value,
      };
      this.SpinnerService.show();
      valueFOrmRegistro.ciudadId = this.ciudadSelected.id_centro_logistico;
      // console.log(valueFOrmRegistro.ciudadId)
      const usuario2 = this.setObjectRegistroUSuarioMen(
        valueFOrmRegistro,
        this.ciudadSelected.id_tienda
      );
      this.nombreUsu = usuario2.usuario;
      console.log(usuario2);
      this.usuarioService
        .guardaUsuario2(usuario2)
        .subscribe((responseUsuario) => {
          // console.log('este es el id tienda: ' + this.ciudadSelected.id_tienda);
          this.succes = true;
          this.save();
          setTimeout(() => {
            this.isVisible = false;
            this.SpinnerService.hide();
          }, 5000);
        });
      window.scroll(0, 0);
      // console.log('REGISTRO EXITOSO');
      /*console.log("Esta es la tienda: " + this.ciudadSelected.id_tienda);
      console.log("Este es el nombre guardado: " + usuario.nombre);
      console.log("Este es el usuario guardado: " + usuario.usuario);
      console.log("Este es el email guardado: " + usuario.email);
      console.log("Este es el direccion guardado: " + usuario.direccion);
      console.log("Este es el telefono guardado: " + usuario.celular);
      console.log("Este es el placa guardado: " + usuario.placa);*/

      //   this.usuarioService
      //     .registrarse(valueFOrmRegistro)
      //     .subscribe((response) => {
      //       console.log(response);
      //     });
      // }
    }
  }

  //GUARDA DATOS DE USUARIO DE FORMULARIO TIENDA
  setObjectRegistroUSuarioMen(
    valueFOrmRegistro: RegistroMen,
    idTienda: string
  ): RegistroUsuariosMen {
    return {
      id_tienda: idTienda,
      rol: '6',
      usuario: valueFOrmRegistro.usuario,
      nombre: valueFOrmRegistro.nombreCompleto,
      direccion: valueFOrmRegistro.direccion,
      celular: valueFOrmRegistro.telefono,
      email: valueFOrmRegistro.email,
      placa: valueFOrmRegistro.placa,
    };
  }

  //RECORTE DE IMAGENES
  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.file = file;
    }
  }

  save() {
    //console.log(this.file);
    // Aqui tienes que enviar el fichero ya a la API
    /*this.fileUploadService.postFile(this.file).subscribe(data => {
      console.log("SUBIOO");
    }, error => {
      console.log("NO SUBIO");
    });*/
    this.fileUploadService.uploadFile(this.file, this.file.name, environment.folderAwsImageLogoMensa);
  }

  fileChangeEvent(event: any): void {
    //console.log(event);
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    //console.log('Este es el nombre de imagen: ' + (this.nombreUsu + '.png'));
    const fileName = this.nombreUsu + '.png';
    //Usage example:
    var file = this.dataURLtoFile(this.croppedImage, fileName);
    //console.log(file);
    this.file = file;
  }

  dataURLtoFile(dataurl, filename) {

    let arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }


  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
    console.log('fffff');
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if (window.pageYOffset > 50) {
      let element = document.getElementById('navbar');
      element.classList.add('sticky');
    } else {
      let element = document.getElementById('navbar');
      element.classList.remove('sticky');
    }
  }
}

